import { render, staticRenderFns } from "./ClassroomTaskDetail.vue?vue&type=template&id=646f36bb&scoped=true"
import script from "./ClassroomTaskDetail.vue?vue&type=script&lang=js"
export * from "./ClassroomTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassroomTaskDetail.vue?vue&type=style&index=0&id=646f36bb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f36bb",
  null
  
)

export default component.exports